import { OverridableComponent } from '@material-ui/core/OverridableComponent'
import SvgIcon, { SvgIconTypeMap } from '@material-ui/core/SvgIcon/SvgIcon'
import clsx from 'clsx'
import React from 'react'

const FilterIcon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>> = (
    props: any
) => (
    <SvgIcon
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        className={clsx('filterIcon', props.className)}
        htmlColor="transparent"
    >
        <g id="icon/action/list_24px">
            <g id="filter">
                <path
                    id="Vector"
                    d="M18.9528 4.35C18.8618 4.13883 18.6501 4 18.4167 4H5.58403C5.3507 4 5.14305 4.13825 5.04797 4.35C4.95697 4.56117 4.99722 4.80967 5.15355 4.98059L9.66658 9.85901V16.25C9.66658 16.4029 9.72841 16.5528 9.83807 16.6619L13.3379 20.1619C13.4511 20.275 13.6004 20.3334 13.7497 20.3334C13.8261 20.3334 13.899 20.3188 13.972 20.2896C14.1907 20.1986 14.333 19.9869 14.333 19.75V9.85901L18.8425 4.98059C19.003 4.80909 19.0432 4.56117 18.9522 4.35H18.9528ZM10.8344 15.7723V9.83335L6.60189 5.16667H7.98724L12.001 9.49793V16.9389C11.3593 16.2973 10.8344 15.7723 10.8344 15.7723Z"
                    fill="white"
                />
            </g>
        </g>
    </SvgIcon>
)

export default FilterIcon
